import React from "react";
import videoBg from "assets/videos/video.mp4";
import * as S from "./styles";

interface IntroProps {
  setIsHome: Function;
}
export const Intro: React.FC<IntroProps> = ({ setIsHome }) => {
  return (
    <S.Container>
      <S.Content className="left">
        <S.Wrapper>
          <S.Title>
            <span>
              TOP <small>10</small>
            </span>
            <br />
            CLIPES
          </S.Title>
          <S.Text>
            Surgidos muito antes do TikTok, os videoclipes se mantêm na
            vanguarda ditando moda, comportamento e fazendo história. Aqui, dez
            nomes revelam quais são seus clipes preferidos.
          </S.Text>
          <S.Credit>Por Claudia Lima</S.Credit>
          <S.Button onClick={() => setIsHome(false)}>
            <S.Icon />
            Confira
          </S.Button>
        </S.Wrapper>
      </S.Content>
      <S.Content className="right">
        <S.Text>
          <p>
            É quase impossível mensurar o legado dos videoclipes para a cultura
            pop. Sem eles, talvez apenas a metade dos artistas que conhecemos
            teria alcançado o sucesso e faturado milhões mundo afora.
          </p>

          <p>
            Os clipes explodiram nos anos 1980, com um bom empurrão da MTV.
            Criada há exatos 40 anos nos EUA, o canal ajudou a redefinir a
            estética da década e movimentou a indústria com vídeos que tinham
            tratamento de cinema – superproduções, com efeitos especiais
            inovadores. O Duran Duran inaugurou a tendência e foi seguido por
            Madonna e Michael Jackson, o primeiro artista negro a ter um clipe
            veiculado no canal. Michael, aliás, zerou o game com <i>Thriller</i>{" "}
            (1983), um curta-metragem de 14 minutos que é referência até hoje e
            abriu portas para artistas como Björk e Lady Gaga, só para citar
            alguns.
          </p>

          <p>
            Apesar de muita gente acreditar que os videoclipes tiveram um
            momento de ostracismo, eles nunca perderam relevância. Prova disso é
            que, de Beyoncé a Anitta, ninguém abre mão de lançar vídeos. Até
            hoje uma ferramenta indispensável.
          </p>

          <p>
            A seguir, perguntamos para artistas, diretores e fashionistas quais
            os videoclipes pop mais marcantes de suas vidas. Confira!
          </p>
        </S.Text>
      </S.Content>
      <S.Video>
        <video muted autoPlay loop playsInline>
          <source src={videoBg} type="video/mp4" />
        </video>
      </S.Video>
    </S.Container>
  );
};
